import { useStaticQuery, graphql } from "gatsby"

export const useContactImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _001: file(relativePath: { eq: "img/contact/background-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      _001_small: file(relativePath: { eq: "img/contact/small001-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(relativePath: { eq: "img/contact/small002-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
